export default{
    logPlatform:"/platform/index.html",
    bigData:"/bigdata/index.html",
    quwoback:"/quwoback/index.html",
    quwoCloud:"/cloud/main.html",
    source:"/source/main.html",
    system:"/system/index.html",
    febs:"/febs/index.html",
    erp:"/erp/index.html",
    plantProtect:"http://nyzbwlw.com/agro_monitor/loginAuto.jsp?loginName=qwx&loginPass=123456"
}